<template>
  <ClientOnly>
    <Error
      v-if="siteStructureNotFound"
      :error="err"
    />
    <Default v-else>
      <Error :error="err" />
    </Default>
    <template #fallback>
      <div class="error-page-layout">
        <div class="error-page">
          <div class="content">
            <span>Error</span>
            <h1>Page not found</h1>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    </template>
  </ClientOnly>
</template>

<script>
import Default from './layouts/default.vue';
import Error from './components/pages/Error.vue';

const SITE_STRUCTURE_ERROR_TEXT = '(Site Structure not found)';

export default {
  components: {
    Default,
    Error,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    siteStructureNotFound() {
      return this.error.message.includes(SITE_STRUCTURE_ERROR_TEXT);
    },
    err() {
      const error = { ...this.error };
      if (this.siteStructureNotFound) {
        error.message = error.message.replace(SITE_STRUCTURE_ERROR_TEXT, '');
      }
      return error;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Minimal layout for ClientOnly fallback only; full error-page styles live in components/pages/Error.vue */
.error-page-layout {
  .error-page {
    display: flex;
    justify-content: center;
    font-size: 14px;
  }
  .content {
    display: flex;
    flex-direction: column;
    padding: 100px;
  }
}
</style>
